import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["select"]
  static values = {
    cookieName: String,
  }

  change() {
    const cookieName = this.cookieNameValue || "selected_language"
    const selected = this.selectTarget.value

    document.cookie = `${encodeURIComponent(cookieName)}=${encodeURIComponent(selected)}; path=/`
    window.location.reload()
  }
}

